import { PhotoWithSkeleton } from "./PhotoWithSkeleton";
import { PowertrainBadge } from "./PowertrainBadge";
import { formatUAH } from "../utils/format";

/**
 * п.7 ТЗ: єдина CTA «Розрахувати» у всіх трьох каталогах (нові Toyota / в наявності / з пробігом).
 * Один компонент картки для всіх трьох, щоб вкладки виглядали логічно схожими (п.31 ТЗ).
 */
export function CarCard(props: {
  photoUrl: string | null;
  title: string;
  subtitle?: string;
  badges?: React.ReactNode;
  priceUAH: number;
  priceLabel?: string; // напр. "від" для каталогу моделей
  onCalculate: () => void;
  onClick?: () => void;
}) {
  return (
    <div className="card car-card" onClick={props.onClick} role={props.onClick ? "button" : undefined}>
      <PhotoWithSkeleton src={props.photoUrl} alt={props.title} />
      <div className="car-card-body">
        <div className="car-card-title">{props.title}</div>
        {props.subtitle && <div style={{ fontSize: 13, color: "var(--color-text-secondary)" }}>{props.subtitle}</div>}
        {props.badges && <div className="car-card-meta">{props.badges}</div>}
        <div className="car-card-footer">
          <div>
            {props.priceLabel && <div className="price-from-label">{props.priceLabel}</div>}
            <div className="price">{formatUAH(props.priceUAH)}</div>
          </div>
          <button
            className="btn btn-primary btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              props.onCalculate();
            }}
          >
            Розрахувати
          </button>
        </div>
      </div>
    </div>
  );
}
